export const markItUpConfig = {
  nameSpace: 'html',
  previewParserPath: '/posts/preview',
  markupSet: [
    { name: 'Bold', key: 'B', openWith: '<span class="b">', closeWith: '</span>' },
    { name: 'Italic', key: 'I', openWith: '<span class="i">', closeWith: '</span>' },
    { name: 'Underline', key: 'U', openWith: '<u>', closeWith: '</u>'} ,
    { name: 'Paragraph', openWith: '<p(!( class="[![Class]!]")!)>', closeWith: '</p>' } ,
    { name: 'Link', key: 'L', openWith: '<a href="[![Link: !: http: //]!]"(!( title="[![Title]!]")!)>', closeWith: '</a>', placeHolder: 'Your text to link...' } ,
    { name: 'Ul', openWith: '<ul>\n', closeWith: '</ul>\n' },
    { name: 'Ol', openWith: '<ol>\n', closeWith: '</ol>\n' },
    { name: 'Li', openWith: '<li>', closeWith: '</li>' },
    { name: 'Цитата', openWith: "<blockquote>", closeWith: '</blockquote>', placeHolder: 'Введите цитату' },
    { name: 'Большой текст', openWith: '<div class="bigtext">', closeWith: '</div>', placeHolder: 'Большой текст' },
    { name: 'Поле с зелеными рамками', openWith: "<div class='green-box'><div class='title'><span>ЗДЕСЬ ЗАГОЛОВОК</span></div>", closeWith: '</div>', placeHolder: 'ЗДЕСЬ ТЕКСТ' },
    { name: 'Цитата', openWith: "<blockquote>", closeWith: '</blockquote>', placeHolder: 'Введите цитату' },
    { name: 'Картинка по центру', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Маленькая картинка по левому краю', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Большая картинка на всю ширину', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Светло серый варн', openWith: "<div class='graywarn'>", closeWith: '</div>', placeHolder: 'текст' },
    { name: 'Серый варн', openWith: "<div class='striped-warn'>", closeWith: '</div>', placeHolder: 'текст' },
    { name: 'Рум-варн', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Варн-ссылка', openWith: "<div class='link-warn'>", closeWith: '</div>', placeHolder: 'текст со ссылкой' },
    { name: 'Большие карты', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Маленькие карты', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Блок кода', openWith: '', closeWith: '', placeHolder: '' },
    { name: 'Picture', key: 'P', replaceWith: "<div class='c-pic'><img src='[![Source: !: http: //]!]' alt='[![Alternative text]!]' itemprop='url' /> </div>" }
  ]
}
